// src/utils/traceLogger.js
import LogSeverityLevel from '@/constants/error/LogSeverityLevel'

export const createTraceLogger = (
  appInsightsInstance,
  enrichProperties = (props) => props
) => {
  const traceLogger = (message, severityLevel, properties = {}) => {
    appInsightsInstance.trackTrace(
      { message, severityLevel },
      enrichProperties(properties)
    )
  }

  return {
    verbose: (message, properties = {}) => {
      traceLogger(message, LogSeverityLevel.Verbose, properties)
    },
    info: (message, properties = {}) => {
      traceLogger(message, LogSeverityLevel.Information, properties)
    },
    warn: (message, properties = {}) => {
      traceLogger(message, LogSeverityLevel.Warning, properties)
    },
    error: (message, properties = {}) => {
      traceLogger(message, LogSeverityLevel.Error, properties)
    },
    critical: (message, properties = {}) => {
      traceLogger(message, LogSeverityLevel.Critical, properties)
    },
  }
}
